<template>
  <div style="height:100%;width:100%;padding-top:30px;">
    <div id="echarts16" :style="charts16Style" style="display: flex;
    align-items: center;"></div>
  </div>
</template>
<script>
export default {
  name: "echarts16",
  props: {
    charts16Style: {
      type: Object,
      default: () => {
        return { width: "100%", height: "100%" };
      }
    },
    echarts16Data: {
      type: Array,
      default: () => {
        return [
          { name: "电器故障", value: 20 },
          { name: "来料故障", value: 30 },
          { name: "软件故障", value: 10 },
          { name: "机械故障", value: 40 }
        ];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.pies()
  },
  methods: {
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts16")
      );
      var option = {
        color: [
          "#B7EFFF",
          "#6AC6F5",
          "#3FA3E1",
          "#2D74A4"
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        // legend: {
        //   // type: "scroll",
        //   orient: "vertical",
        //   show: true,
        //   left: 10,
        //   bottom: 28,
        //   icon: "circle",
        //   itemWidth: 10, // 图例图形宽度
        //   itemHeight: 10, // 图例图形高度
        //   textStyle: {
        //     fontSize: 12,
        //     color: "#fff"
        //   },
        //   data: _this.echarts16Data
        // },
        calculable: true,
        series: [
          {
            name: "故障分析",
            type: "pie",
            radius: [50, 70],
            center: ["50%", "50%"],
            roseType: "area",
            data: _this.echarts16Data,
            label: {
              normal: {
                formatter: function(data) {
                    return (
                        data.name+"\n"+data.percent+"%"
                    )
                },
                show: true,
                position: "bottom", //文字显示位置
                textStyle: {
                  fontSize: "14",
                  fontWeight: "normal"
                }
              }
            },
            lableLine: {
              normal: {
                show: false,
                length: "1"
                // avoidLabelOverlap: false
              }
            }
          }
        ]
      };

      behaviorpie.setOption(option);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts7.vue